"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalizeFirstLetter = void 0;

var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

exports.capitalizeFirstLetter = capitalizeFirstLetter;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/utils.js
// module id = 76
// module chunks = 0